export default {"src":"/_next/static/media/coachmark-image.718a8aed.svg","height":72,"width":73,"blurWidth":0,"blurHeight":0};